import api from '../../../configs/instanceApi';

export const getPsrs = (codeProducts, isFlagAccreditation = true) => {
  const url = `/accreditation-quotations/psrs?isFlagAccreditation=${isFlagAccreditation}&codeProduct=${codeProducts}`;
  return api.get(url);
};

export const sendPsrs = (ecIdentity, psrs, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations/${ecIdentity}/psrs`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.patch(url, psrs, config);
};
